export default "__VITE_ASSET__CnmIPqv9__"